import BaseAttributeCollection from './baseAttributeCollection';
import TalentCollection from './talentCollection';
import BaseAttribute from './baseAttribute';

export default class AllCollection {
  private baCollection: BaseAttributeCollection;
  private taCollection: TalentCollection;

  constructor() {
    this.baCollection = new BaseAttributeCollection();
    this.taCollection = new TalentCollection();
  }

  get allValues(): BaseAttribute[] {
    return [...this.baCollection.allValues, ...this.taCollection.allValues];
  }

  public getNameByAbbreviation(abbreviation: string) {
    const foundValues = this.allValues.filter((value) => value.abbreviation === abbreviation);
    if (foundValues.length > 1) {
      throw new Error('More than one BaseAttribute found for abbreviation ' + abbreviation);
    }

    return foundValues[0].name;
  }

  public getCategoryByAbbreviation(abbreviation: string) {
    const baCategory = this.baCollection.getCategoryByAbbreviation(abbreviation);
    if (baCategory !== null) {
      return baCategory;
    }
    const taCategory = this.taCollection.getCategoryByAbbreviation(abbreviation);
    if (taCategory !== null) {
      return taCategory;
    }
    throw new Error('Unable to find category for abbreviation: ' + abbreviation);
  }

  public getAttributeByAbbreviation(abbreviation: string) {
    const foundValue = this.allValues.find((value) => value.abbreviation === abbreviation);

    if (typeof foundValue === 'undefined') {
      throw new Error('Attribute with abbreviation ' + abbreviation + ' not found in allValues');
    }

    return foundValue.getClone();
  }
}
